import { useLayoutEffect, useRef, useState } from "react";

/**
 * Tracks the natural (content) size of an element via `ResizeObserver`, rounded up to whole
 * pixels. Use it to animate to an explicit px width/height, since CSS cannot transition to
 * `auto`. Returns the ref to attach and the current size.
 */
export function useMeasuredSize() {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => {
      const rect = el.getBoundingClientRect();
      setSize({ width: Math.ceil(rect.width), height: Math.ceil(rect.height) });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, size] as const;
}
